import fetch from 'isomorphic-fetch'
import https from 'https'

export const REQUEST_NOTIFICATIONS = 'REQUEST_NOTIFICATIONS'
export const RECEIVE_NOTIFICATIONS = 'RECEIVE_NOTIFICATIONS'
export const INVALIDATE_NOTIFICATIONS = 'INVALIDATE_NOTIFICATIONS'

export const REQUEST_NOTIFICATION_COUNT_DATA = 'REQUEST_NOTIFICATION_COUNT_DATA'
export const RECEIVE_NOTIFICATION_COUNT_DATA = 'RECEIVE_NOTIFICATION_COUNT_DATA'
export const INVALIDATE_NOTIFICATION_COUNT_DATA = 'INVALIDATE_NOTIFICATION_COUNT_DATA'


function requestNotifications(){
  return{
    type: REQUEST_NOTIFICATIONS
  }
}

function receiveNotifications(notifications){
  return {
    type: RECEIVE_NOTIFICATIONS,
    notifications,
    receivedAt: Date.now()
  }
}

export function invalidateNotificationCountData() {
  return {
    type: INVALIDATE_NOTIFICATION_COUNT_DATA
  }
}

function requestNotificationCount(){
  return{
    type: REQUEST_NOTIFICATION_COUNT_DATA
  }
}

function receiveNotificationCount(data){
  return {
    type: RECEIVE_NOTIFICATION_COUNT_DATA,
    data,
    receivedAt: Date.now()
  }
}

function fetchNotifications(){
  return dispatch => {
    dispatch(requestNotifications());

    return fetch('https://'+__API_HOST__+__NOTIFICATIONS_URL__)
      .then(response => response.json())
      .then( json => dispatch(receiveNotifications(json.data)) )
  }
}

export function fetchNotificationCount(){
  return dispatch => {
    dispatch(requestNotificationCount());

    return fetch('https://'+__API_HOST__+__NOTIFICATIONS_COUNT_URL__)
      .then(response => response.json())
      .then( json => dispatch(receiveNotificationCount(json.data)) )

  }
}

function shouldFetchNotifications(state) {
  const notifications = state.notifications;

  if (!notifications) {
    return true
  } else if (notifications.isFetching) {
    return false
  } else {
    return notifications.didInvalidate
  }
}

export function fetchMessagesIfNeeded() {
  return (dispatch, getState) => {
    if (shouldFetchNotifications(getState())) {
      return dispatch(fetchNotifications())
    }
  }
}



// WEBPACK FOOTER //
// ./src/actions/NotificationAction.js